import React from "react";

export default function RoleWidget(props) {
  return <div className="role-widget">{props.role}</div>;
}
